import React, { useEffect, useState } from "react";
import { Table, Tooltip } from "antd";
import axios from "axios";
import { useDispatch, useSelector } from "react-redux";
import { all_routes } from "../../Router/all_routes";
import { Modal, Button } from "antd";
import {set_product_edit} from "../../core/redux/action";
import { useNavigate } from "react-router-dom";
import AuctionStatus from "./AuctionStatus";
import withReactContent from "sweetalert2-react-content";
import Swal from "sweetalert2";
const ProductBidding = () => {
  const l = useSelector((state) => state.language || "en");
  const t = useSelector((state) => state.translation || "en");
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const route = all_routes;

  const [productData, setProductData] = useState([]);
  const [selectedBidders, setSelectedBidders] = useState([]);
  const [productID, setProductID] = useState("");
  
  const [sku, setSku] = useState("");
  const [checkBidStatus, setCheckBidStatus] = useState(false);
  const [winBidderID, setWinBidderID] = useState(null);
  const [acceptedBidAmount, setAcceptedBidAmount] = useState(null);
  
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const permissions = useSelector(state => state.permissions) || [];
  const roleTitle = useSelector(state => state.roleTitle) || '';
  const roleTitleAdmin = useSelector(state => state.roleTitleAdmin) || '';
  const MySwal = withReactContent(Swal);
  const canView = roleTitle === roleTitleAdmin || permissions.some(p => p.Module.toLowerCase() === 'users' && p.Permission.toLowerCase() === 'view');

  const getProductsApi = async () => {
    setLoading(true);
    try {
      const res = await axios.get("getuserauctionproduct/");
      if (res.data.productList) {
        setProductData(res.data.productList.reverse());
      }
    } catch (error) {
      console.error("Error fetching product data:", error);
    } finally {
      setLoading(false);
    }
  };
  const viewProduct = async (record) => {
    record.viewOnly = true;
    dispatch(set_product_edit(record))
    navigate(route.addproduct)
  }
  useEffect(() => {
    getProductsApi();
  }, []);
  const openModal = (bidHistory,prod,variant) => {
    console.log('bidHistory',bidHistory);
    setWinBidderID(null)
    setAcceptedBidAmount(null)
    setSku(null);
    setProductID(null);
    setSelectedBidders(null);
    setProductID(prod._id);
    if(variant)
    {
      setSku(variant.sku || undefined)

      if(variant.acceptedBidder)
      {
        setWinBidderID(variant.acceptedBidder)
        setAcceptedBidAmount(variant.acceptedBidAmount)
        setCheckBidStatus(true)
      }
      else
      {
        setWinBidderID(null)
        setAcceptedBidAmount(null)
        setCheckBidStatus(false)
      }
    }
    else
    {
      if(prod.acceptedBidder)
      {
        setWinBidderID(prod.acceptedBidder)
        setAcceptedBidAmount(prod.acceptedBidAmount)
        setCheckBidStatus(true)
      }
      else
      {
        setWinBidderID(null)
        setAcceptedBidAmount(null)
        setCheckBidStatus(false)
      }
    }
      setSelectedBidders(bidHistory);
    setIsModalOpen(true);
  };

  const handleAccept = async(bidderId, bid, productUrl) => {
    try
    {
      console.log("Accepted Bidder ID:", bidderId);
      
      console.log("Accepted bid:", bid);
      var obj = {
        bidderId:bidderId,
        productId:productID,
        sku: sku || undefined,
        bid: bid,
        productUrl: productUrl
      }
      if(!sku || sku == "")
        obj = {
          bidderId:bidderId,
          productId:productID,
          bid: bid,
          productUrl: productUrl
        }
        
      let result = await axios.post("acceptauction/", obj);
      if (result.status == 200) {
        MySwal.fire({
          position: "top-end",
          icon: "success",
          title: "Bid Accepted!",
          showConfirmButton: false,
          timer: 3000,
          }).then(() => {
            setIsModalOpen(false);
            getProductsApi()
          });
      }
    }
    catch (error) {
      MySwal.fire({
        position: "top-end",
        icon: "error",
        title: error.response.data.message,
        showConfirmButton: false,
        timer: 3000,
      });
    
      console.error("Error fetching product data:", error);
    }
   

    // Call API to accept the bid
  };
  const renderBidderDetail = (record) => {
    if (record.productType === "variable") {
      // Handle variable products
      return record.productAttributes.map((variant) => (
        <div key={variant.sku} style={{ marginBottom: "10px" }}>
          <strong>Attribute({variant.attributes.map(attr => Object.values(attr)[0]).join('|')}): </strong>
          {variant.bidHistory && variant.bidHistory.length > 0 ? (
            <Button  type="link" style={{ color: "#0977DC",paddingLeft: 0 }} onClick={() => openModal(variant.bidHistory,record,variant)}>
              {t[l]?.["viewDetails"] || "View Details"}
            </Button>
            
          ) : (
            <span>{t[l]?.["noBidders"] || "No Bidders"}</span>
          )}
        </div>
      ));
    } else {
      // Handle simple products
      return record.bidHistory && record.bidHistory.length > 0 ? (
        <div>
          <Button type="link" style={{ color: "#0977DC",paddingLeft: 0 }} onClick={() => openModal(record.bidHistory,record,null)}>
            {t[l]?.["viewDetails"] || "View Details"}
          </Button>
        </div>
      ) : (
        <span>{t[l]?.["noBidders"] || "No Bidders"}</span>
      );
    }
  };
  const renderTimeDetail = (record) => {
    if (record.productType === "variable") {
      // Handle variable products
      return record.productAttributes.map((variant) => (
        <div key={variant.sku} style={{ marginBottom: "10px" }}>
           <AuctionStatus aucSD={variant.aucSD} aucED={variant.aucED} />
        </div>
      ));
    } else {
      // Handle simple products
      return record && record.length > 0 ? (
        <div>
          <AuctionStatus aucSD={record.aucSD} aucED={record.aucED} />
        </div>
      ) : (
        <>
          <AuctionStatus aucSD={record.aucSD} aucED={record.aucED} />
        </>
      );
    }
  };
  const columns = [
    {
      title: t[l]?.["storeName"] || "Store Name",
      dataIndex: "storeName",
      key: "storeName",
    },
    {
      title: t[l]?.["productName"] || "Product Name",
      dataIndex: "name",
      key: "name",
    },
    {
      title: t[l]?.["status"] || "Status",
      dataIndex: "status",
      key: "status",
      render: (_, record) => {
        if (record.productType === "variable") {

          const hasActive = record.productAttributes.some(attr => attr.bidStatus === "active");
          const hasCancelled = record.productAttributes.some(attr => attr.bidStatus === "canceled");
      
          if (hasActive) {
            return "Active";
          } else if (hasCancelled) {
            return "Close";
          } else {
            return "Not Started";
          }
        } else {
          if(record.bidStatus == "canceled")
            return "Close";
          else if(record.bidStatus == "active")
            return "Active"
          else
            return record.bidStatus || "N/A";
        }
      },
      
    },
    {
      title: t[l]?.["productPrice"] || "Product Price",
      dataIndex: "price",
      key: "price",
    },
   
    {
      title: t[l]?.["NoOfBidders"] || "No. of Bidders",
      render: (_, record) => {
        if (record.productType === "variable") {
          return record.productAttributes.reduce(
            (total, variant) => total + (variant.bidHistory?.length || 0),
            0
          );
        } else {
          return record.bidHistory ? record.bidHistory.length : "N/A";
        }
      },
    },
    
    {
      title: t[l]?.["productDetail"] || "Product Detail",
      key: "productDetail",
      render: (_, record) => (
        <Tooltip title={record.description || t[l]?.["noDescription"] || "No description"}>
          <div 
            onClick={() => viewProduct(record)} 
            style={{ color: "#0977DC", cursor: "pointer", textDecoration: "underline" }}
          >
            {t[l]?.["viewProduct"] || "View Product"}
          </div>

          
        </Tooltip>
      ),
    },
    
    {
      title: t[l]?.["bidderDetail"] || "Bidder’s Detail",
      render: (_, record) => renderBidderDetail(record),
    },
    {
      title: t[l]?.["timeStatus"] || "Time Status",
      render: (_, record) => renderTimeDetail(record),
    },
  ];

  return (
  <div>
      <div className={`${l === 'ar' ? 'page-wrapper-rtl' : 'page-wrapper'}`}>
          {canView ? (
        <div className="content">
          <div className="page-header">
            <div className="add-item d-flex">
                <div className="page-title">
                    <h4>{t?.[l]?.["product_bidding"] || "Product Bidding"}</h4>
                    <h6>{t?.[l]?.["manage_your_product_bidding"] || "Manage Your Product Bidding"}</h6>
                </div>
            </div>
          </div>
          <div className="card table-list-card">
            <div className="card-body">
     
              <div className="table-responsive">
                <Table
                  // loading={loading}
                  className="table datanew"
                  columns={columns}
                  dataSource={productData}
                   rowKey="_id"
                   loading={loading}
                />
              </div>
            </div>
          </div>
        </div>
        ) : (
          <div className={`${l === 'ar' ? 'page-wrapper-rtl' : 'page-wrapper'}`}>
              <div className="content">
                  <p>{t[l]?.["no_permission"] || "You do not have permission to view this page."}</p>
              </div>
          </div>
      )}

      </div>
       {/* Modal for Bidders */}
      <Modal
        title={t[l]?.["bidders_details"] || "Bidder's Details"}
        visible={isModalOpen}
        onCancel={() => setIsModalOpen(false)}
        footer={null}
        width="70%"  // Set width as a percentage of the viewport width
        bodyStyle={{ maxHeight: '60vh', overflowY: 'auto' }} // Optional: allows scrolling in the body of the modal
      >
        <Table
          dataSource={selectedBidders}
          rowKey={(record) => record._id}
          columns={[
            // {
            //   title: t[l]?.["bidderId"] || "Bidder ID",
            //   dataIndex: "bidderId",
            // },
            {
              title: t[l]?.["customer_name"] || "Customer Name",
              dataIndex: "customerName",
            },
            {
              title: t[l]?.["address"] || "Address",
              dataIndex: "address",
            },
            {
              title: t[l]?.["email"] || "Email",
              dataIndex: "email",
            },
            {
              title: t[l]?.["bidAmount"] || "Bid Amount",
              dataIndex: "bid",
            },
            {
              title: t[l]?.["bidDate"] || "Bid Date",
              dataIndex: "date",
              render: (date) => new Date(date).toLocaleString(),
            },
            {
              title: t[l]?.["actions"] || "Actions",
              render: (_, bidder) => (
                <div>
                  
                  {!checkBidStatus &&
                    <button type="button" className="btn btn-submit"  onClick={() => handleAccept(bidder.bidderId, bidder.bid, bidder.productUrl)}>
                      {t?.[l]?.["accept"] || "Accept"}
                    </button>
                  }
                  {checkBidStatus && bidder.bidderId == winBidderID && bidder.bid == acceptedBidAmount &&
                      <> {t?.[l]?.["accepted"] || "Accepted"}</>
                  }
                </div>
              ),
            },
          ]}
        />
      </Modal>

    </div>
  );
};

export default ProductBidding;